import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { getCustomGroupRenderer } from "../../../other/utils/utils.jsx";
import ColumnBase from "../../columns/ColumnBase.jsx";
import { tagWidget } from "../../../other/utils/otherUtils.jsx";

export default class ImportedFieldsColumn extends ColumnBase {
  static get $name() {
    return "ImportedFieldsColumn";
  }

  static get fields() {
    return [
      { name: "swivuListTitle", readOnly: true, type: "string", defaultValue: "Imported Fields" },
      { name: "swivuListSearchKey",type: "string", readOnly: true, defaultValue: "text" },
      { name: "popupCls",type: "array", readOnly: true, defaultValue: ["minimal-gradient-editor"] },
    ];
  }

  static get type() {
    return WIDGET_KEYS.importedFieldsColumn;
  }

  static get defaults() {
    return {
      field: "importedField",
      text: "Imported Fields",
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      flex: 1,
      sortable: false,
      groupable: false,
      groupRenderer(e) {
        return getCustomGroupRenderer(e, "importedField");
      },
      editor: false,
    };
  }

  onLoad(items) {
    this.swivuListItems = items.map((item, index) => {
      return {
        /* Todo: This id is being used to reconcile with the phantom id. for some reason the display values are not showing up correctly.
        So by giving an index to the list items the display values are populating correctly */
        id: index,
        text: item
      }
    });
  }

  getSwivuListItemDisplayValue(record) {
    return record.text;
  }

  getSelectedSwivuListItem(gridRecord) {
    return this.swivuListItems.find(item => {
      return gridRecord.importedField === item.text;
    });
  }

  onSwivuListSelectionChange(gridRecord, [newRecord]) {
    gridRecord.importedField = newRecord?.text;
  }

  renderer({ record }) {
    return tagWidget(record[this.field])
  }
}

ColumnStore.registerColumnType(ImportedFieldsColumn);